export const pl: Record<string, string> = {
  // --- Units ---
  'unit.infantry': 'Piechota',
  'unit.recon': 'Zwiad',
  'unit.cavalry': 'Kawaleria',
  'unit.jeep': 'Jeep',
  'unit.light-tank': 'Cz. lekki',
  'unit.medium-tank': 'Cz. \u015bredni',
  'unit.heavy-tank': 'Cz. ci\u0119\u017cki',
  'unit.apc': 'Transporter',
  'unit.aa-flakpanzer': 'Flakpanzer',
  'unit.long-range-artillery': 'Artyleria',
  'unit.anti-tank-artillery': 'Dz. ppanc.',
  'unit.supply-truck': 'Zaopatrzenie',
  'unit.medic': 'Medyk',
  'unit.officer': 'Oficer',
  'unit.hero-polska-a': 'Maria Skłodowska-Curie',
  'unit.hero-polska-b': 'Jan Czochralski',
  'unit.hero-iii-rzesza-a': 'Fritz Haber',
  'unit.hero-iii-rzesza-b': 'Karl Landsteiner',
  'unit.hero-francja-a': 'Jean Perrin',
  'unit.hero-francja-b': 'Alexis Carrel',
  'unit.hero-zsrr-a': 'Konstantin Ciołkowski',
  'unit.hero-zsrr-b': 'Iwan Pawłow',
  'unit.hero-usa-a': 'Thomas Edison',
  'unit.hero-usa-b': 'Robert Goddard',
  'unit.hero-wlochy-a': 'Guglielmo Marconi',
  'unit.hero-wlochy-b': 'Vito Volterra',
  'unit.hero-japonia-a': 'Hideyo Noguchi',
  'unit.hero-japonia-b': 'Shibasaburō Kitasato',
  'unit.hero-jugoslawia-a': 'Nikola Tesla',
  'unit.hero-jugoslawia-b': 'Mihajlo Pupin',
  'unit.hero-wielka-brytania-a': 'Ernest Rutherford',
  'unit.hero-wielka-brytania-b': 'Joseph John Thomson',
  'unit.officer.desc': 'Oficer wsparcia. Aura: +10% obrony sojusznikom w zasięgu 1. Zdolność: nalot bombowy (obszar 3×3, swój ostrzał rani też własnych). Słaby w walce.',
  'unit.hero-polska-a.desc': 'Maria Skłodowska-Curie — aura lecznicza: sojusznicy w zasięgu 3 odzyskują 1 HP co turę. Jeden żywy egzemplarz na gracza.',
  'unit.hero-polska-b.desc': 'Jan Czochralski — aura pancerna: +15% obrony sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-iii-rzesza-a.desc': 'Fritz Haber — aura siły ognia: +15% ataku sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-iii-rzesza-b.desc': 'Karl Landsteiner — aura lecznicza: +1 HP/turę sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-francja-a.desc': 'Jean Perrin — aura zwiadu: +1 zasięgu wzroku sojusznikom w zasięgu 3. Jeden żywy egzemplarz na gracza.',
  'unit.hero-francja-b.desc': 'Alexis Carrel — aura lecznicza: +1 HP/turę sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-zsrr-a.desc': 'Konstantin Ciołkowski — aura mobilności: +1 ruchu sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-zsrr-b.desc': 'Iwan Pawłow — aura bojowa: +10% ataku sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-usa-a.desc': 'Thomas Edison — aura zwiadu: +1 zasięgu wzroku sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-usa-b.desc': 'Robert Goddard — aura mobilności: +1 ruchu sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-wlochy-a.desc': 'Guglielmo Marconi — aura łączności: +1 zasięgu wzroku sojusznikom w zasięgu 3. Jeden żywy egzemplarz na gracza.',
  'unit.hero-wlochy-b.desc': 'Vito Volterra — aura obronna: +10% obrony sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-japonia-a.desc': 'Hideyo Noguchi — aura lecznicza: +1 HP/turę sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-japonia-b.desc': 'Shibasaburō Kitasato — aura obronna: +10% obrony sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-jugoslawia-a.desc': 'Nikola Tesla — aura zwiadu: +1 zasięgu wzroku sojusznikom w zasięgu 3. Jeden żywy egzemplarz na gracza.',
  'unit.hero-jugoslawia-b.desc': 'Mihajlo Pupin — aura bojowa: +10% ataku sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-wielka-brytania-a.desc': 'Ernest Rutherford — aura siły ognia: +15% ataku sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'unit.hero-wielka-brytania-b.desc': 'Joseph John Thomson — aura zwiadu: +1 zasięgu wzroku sojusznikom w zasięgu 2. Jeden żywy egzemplarz na gracza.',
  'order.airStrike': 'Nalot bombowy',
  'order.recon': 'Zwiad lotniczy',
  'unit.plane-fighter': 'My\u015bliwiec',
  'unit.plane-bomber': 'Bombowiec',
  'unit.plane-transport': 'Samolot tr.',
  'unit.ship-battleship': 'Pancernik',
  'unit.ship-submarine': 'Okr\u0119t podn.',
  'unit.infantry-bazooka': 'Piechota ppanc.',
  'unit.tank-destroyer': 'Niszczyciel',
  'unit.ship-aircraft-carrier': 'Lotniskowiec',
  'unit.ship-transport': 'Statek tr.',
  'unit.infantry.desc': 'Podstawowa jednostka l\u0105dowa. Tania i szybka w szkoleniu, zdolna do przejmowania budynk\u00f3w. Potrafi przemieszcza\u0107 si\u0119 przez g\u00f3ry, cho\u0107 wolniej.',
  'unit.recon.desc': 'Szybka i tania jednostka zwiadowcza. S\u0142aba w walce, ale \u015bwietna do eksploracji. Potrafi przechodzi\u0107 przez g\u00f3ry jak piechota.',
  'unit.cavalry.desc': 'Szybka jednostka konna. Doskona\u0142a do flankowania i rajd\u00f3w, ale lekki pancerz.',
  'unit.jeep.desc': 'Zwinny pojazd terenowy. Silniejszy od piechoty, ale bezbronny wobec czo\u0142g\u00f3w, artylerii i samolot\u00f3w.',
  'unit.light-tank.desc': 'Zwinny pojazd pancerny. Szybszy od \u015bredniego czo\u0142gu, skuteczny przeciw piechocie, ale l\u017cejszy pancerz.',
  'unit.medium-tank.desc': 'Zr\u00f3wnowa\u017cona jednostka pancerna o dobrej sile ognia i wytrzyma\u0142o\u015bci. Trzon si\u0142 pancernych.',
  'unit.heavy-tank.desc': 'Pot\u0119\u017cny ci\u0119\u017cki czo\u0142g. Niszczycielska si\u0142a ognia i gruby pancerz, ale bardzo wolny.',
  'unit.apc.desc': 'Transporter opancerzony. Nie posiada uzbrojenia, ale mo\u017ce przewozi\u0107 piechot\u0119, przyspieszaj\u0105c jej dotarcie na lini\u0119 frontu.',
  'unit.aa-flakpanzer.desc': 'Pojazd przeciwlotniczy. Skuteczny przeciw wszystkim celom, szczeg\u00f3lnie gro\u017any dla samolot\u00f3w.',
  'unit.long-range-artillery.desc': 'Artyleria dalekiego zasi\u0119gu. Ogromny zasi\u0119g (3\u20135), ale wolna i krucha.',
  'unit.anti-tank-artillery.desc': 'Dzia\u0142o przeciwpancerne. Niszczycielskie przeciw celom opancerzonym na kr\u00f3tkim dystansie (1\u20132).',
  'unit.supply-truck.desc': 'Ci\u0119\u017car\u00f3wka zaopatrzeniowa. Uzupe\u0142nia zaopatrzenie s\u0105siednich przyjaznych jednostek do pe\u0142na. Niezb\u0119dna w ofensywach daleko od baz.',
  'unit.medic.desc': 'Pojazd medyczny. Leczy pobliskie przyjazne jednostki l\u0105dowe. Nie leczy samego siebie.',
  'unit.plane-fighter.desc': 'Samolot my\u015bliwski o du\u017cym zasi\u0119gu ruchu. Ignoruje przeszkody terenowe, ale podatny na ostrza\u0142 przeciwlotniczy.',
  'unit.plane-bomber.desc': 'Ci\u0119\u017cki bombowiec. Niszczycielskie ataki na cele naziemne, ale wolny i kruchy.',
  'unit.plane-transport.desc': 'Transport powietrzny dla piechoty. Du\u017ca mobilno\u015b\u0107, ale ca\u0142kowicie bezbronny i kruchy.',
  'unit.ship-battleship.desc': 'Pot\u0119\u017cny pancernik z dalekob\u00f3jnym ostrza\u0142em. Dominuje na wodach, ale nie mo\u017ce operowa\u0107 na l\u0105dzie.',
  'unit.ship-submarine.desc': 'Skryty morski napastnik. Tani z dobrym zasi\u0119giem, ale s\u0142aby pancerz.',
  'unit.infantry-bazooka.desc': 'Piechota przeciwpancerna uzbrojona w bazook\u0119. Wysoka si\u0142a ognia przeciw pojazdom, ale nie mo\u017ce przejmowa\u0107 budynk\u00f3w.',
  'unit.tank-destroyer.desc': 'Szybki niszczyciel czo\u0142g\u00f3w. Niszczycielski przeciw pancerzom, ale sam lekko opancerzony \u2014 szklany dzia\u0142on.',
  'unit.ship-aircraft-carrier.desc': 'P\u0142ywaj\u0105ca baza lotnicza. Nieuzbrojony, ale mo\u017ce przewozi\u0107 do 2 samolot\u00f3w i ma doskona\u0142\u0105 widoczno\u015b\u0107.',
  'unit.ship-transport.desc': 'Morski transport jednostek l\u0105dowych. Przewozi do 2 pojazd\u00f3w lub piechoty przez wod\u0119.',

  // --- Faction-unique units ---
  'unit.polska-ulani': 'U\u0142ani',
  'unit.polska-ulani.desc': 'Elitarna kawaleria polska. Szybsza i silniejsza od zwyk\u0142ej kawalerii, zdolna do szar\u017c i przejmowania budynk\u00f3w.',
  'unit.polska-7tp': 'Czo\u0142g 7TP',
  'unit.polska-7tp.desc': 'Polski czo\u0142g lekki 7TP. Lepiej opancerzony i uzbrojony ni\u017c standardowy lekki czo\u0142g, z celnym dzia\u0142em 37mm.',
  'unit.zsrr-t34': 'T-34',
  'unit.zsrr-t34.desc': 'Radziecki czo\u0142g \u015bredni T-34. Legendarna konstrukcja ze sko\u015bnym pancerzem i niezawodnym silnikiem diesla.',
  'unit.zsrr-katiusza': 'Katiusza',
  'unit.zsrr-katiusza.desc': 'Radziecka wyrzutnia rakiet BM-13 \u201eKatiusza\u201d. Wi\u0119kszy zasi\u0119g i niszczycielskie salwy rakietowe.',
  'unit.iii-rzesza-tiger': 'Tiger I',
  'unit.iii-rzesza-tiger.desc': 'Niemiecki czo\u0142g ci\u0119\u017cki Tiger I. Legendarny gruby pancerz i niszczycielskie dzia\u0142o 88mm \u2014 postrach pola bitwy.',
  'unit.iii-rzesza-stuka': 'Ju-87 Stuka',
  'unit.iii-rzesza-stuka.desc': 'Niemiecki bombowiec nurkuj\u0105cy Junkers Ju-87 Stuka. Precyzyjne bombardowanie z lotu nurkowego, przera\u017caj\u0105ca syrena.',
  'unit.usa-sherman': 'M4 Sherman',
  'unit.usa-sherman.desc': 'Ameryka\u0144ski czo\u0142g \u015bredni M4 Sherman. Niezawodny i produkowany masowo, trzon si\u0142 pancernych aliant\u00f3w.',
  'unit.usa-lcvp-higgins': 'LCVP Higgins',
  'unit.usa-lcvp-higgins.desc': 'Ameryka\u0144ska barka desantowa LCVP. Szybsza i pojemniejsza ni\u017c zwyk\u0142y transport morski \u2014 klucz do operacji desantowych.',
  'unit.wlochy-l3-33': 'L3/33',
  'unit.wlochy-l3-33.desc': 'W\u0142oska tankietka L3/33. Szybka i zwinna, idealna do rozpoznania i szybkich rajd\u00f3w.',
  'unit.wlochy-sm79-sparviero': 'SM.79 Sparviero',
  'unit.wlochy-sm79-sparviero.desc': 'W\u0142oski my\u015bliwiec Savoia-Marchetti SM.79 \u201eSparviero\u201d. Szybki i zwrotny, z doskona\u0142\u0105 widoczno\u015bci\u0105.',
  'unit.japonia-chi-ha': 'Typ 97 Chi-Ha',
  'unit.japonia-chi-ha.desc': 'Japo\u0144ski czo\u0142g \u015bredni Typ 97 Chi-Ha. Niezawodny i zwinny, g\u0142\u00f3wny czo\u0142g armii cesarskiej.',
  'unit.japonia-a6m-zero': 'A6M Zero',
  'unit.japonia-a6m-zero.desc': 'Japo\u0144ski my\u015bliwiec Mitsubishi A6M Zero. Legendarny zasi\u0119g i zwrotno\u015b\u0107, dominowa\u0142 nad Pacyfikiem.',
  'unit.francja-renault-r35': 'Renault R35',
  'unit.francja-renault-r35.desc': 'Francuski czo\u0142g lekki Renault R35. Grubszy pancerz ni\u017c inne lekkie czo\u0142gi, solidna konstrukcja.',
  'unit.francja-ms406': 'MS.406',
  'unit.francja-ms406.desc': 'Francuski my\u015bliwiec Morane-Saulnier MS.406. Niezawodny i solidny, g\u0142\u00f3wny my\u015bliwiec Arm\u00e9e de l\'Air.',
  'unit.jugoslawia-partyzanci': 'Partyzanci',
  'unit.jugoslawia-partyzanci.desc': 'Jugos\u0142owia\u0144scy partyzanci. Elitarni bojownicy ruchu oporu \u2014 szybsi, wytrzymalsi i sprawniejsi od zwyk\u0142ej piechoty.',
  'unit.jugoslawia-ba64': 'BA-64',
  'unit.jugoslawia-ba64.desc': 'Samoch\u00f3d pancerny BA-64. Szybki zwiad z lepsz\u0105 ochron\u0105 i zasi\u0119giem obserwacji.',
  'unit.wielka-brytania-komandosi': 'Komandosi',
  'unit.wielka-brytania-komandosi.desc': 'Brytyjscy komandosi. Elitarne jednostki szturmowe \u2014 niszczycielski atak i twarda obrona.',
  'unit.wielka-brytania-churchill': 'Churchill',
  'unit.wielka-brytania-churchill.desc': 'Brytyjski czo\u0142g piechoty Churchill. Wyj\u0105tkowo gruby pancerz i dobre uzbrojenie \u2014 twierdza na g\u0105sienicach.',

  // --- Buildings ---
  'building.hq': 'Baza',
  'building.city': 'Miasto',
  'building.barracks': 'Koszary',
  'building.vehicle-factory': 'Fabryka czo\u0142g\u00f3w',
  'building.motor-pool': 'Park motorowy',
  'building.airport': 'Lotnisko',
  'building.port': 'Port',
  'building.bunker': 'Bunkier',

  // --- Terrain ---
  'terrain.plains': 'R\u00f3wnina',
  'terrain.forest': 'Las',
  'terrain.mountain': 'G\u00f3ry',
  'terrain.road': 'Droga',
  'terrain.water': 'Woda',
  'terrain.bridge': 'Most',
  'terrain.coast': 'Wybrzeże',

  // --- Factions ---
  'faction.polska': 'Polska',
  'faction.iii-rzesza': 'III Rzesza',
  'faction.francja': 'Francja',
  'faction.zsrr': 'ZSRR',
  'faction.usa': 'USA',
  'faction.wlochy': 'W\u0142ochy',
  'faction.japonia': 'Japonia',
  'faction.jugoslawia': 'Jugos\u0142awia',
  'faction.wielka-brytania': 'Wielka Brytania',

  // --- Faction descriptions ---
  'faction.polska.desc': 'Odrodzona po 123 latach zabor\u00f3w, II Rzeczpospolita budowa\u0142a nowoczesn\u0105 armi\u0119 w cieniu dw\u00f3ch mocarstw. Styl gry oparty na mobilno\u015bci \u2014 szybcy u\u0142ani i lekkie czo\u0142gi 7TP pozwalaj\u0105 na zaskakuj\u0105ce uderzenia.',
  'faction.iii-rzesza.desc': 'Trzecia Rzesza pod rz\u0105dami NSDAP budowa\u0142a pot\u0119\u017cn\u0105 machin\u0119 wojenn\u0105 \u0142ami\u0105c traktat wersalski. Ci\u0119\u017cki pancerz Tigera i niszczycielskie Stuki daj\u0105 przewag\u0119 w bezpo\u015brednim starciu.',
  'faction.francja.desc': 'Francja wci\u0105\u017c pami\u0119ta\u0142a rze\u017a Verdun i budowa\u0142a Lini\u0119 Maginota licz\u0105c na obron\u0119. My\u015bliwce MS.406 i lekkie Renault R35 to wyb\u00f3r dla gracza ceni\u0105cego defensywn\u0105 taktyk\u0119.',
  'faction.zsrr.desc': 'Zwi\u0105zek Radziecki prowadzi\u0142 gwa\u0142town\u0105 industrializacj\u0119 kosztem milion\u00f3w, buduj\u0105c najwi\u0119ksz\u0105 armi\u0119 \u015bwiata. Niezawodne T-34 i katiusze oferuj\u0105 pot\u0119\u017cn\u0105 si\u0142\u0119 ognia \u2014 masowy atak przyt\u0142aczaj\u0105cy przeciwnika.',
  'faction.usa.desc': 'Stany Zjednoczone za oceanem budowa\u0142y pot\u0119g\u0119 przemys\u0142ow\u0105, wci\u0105\u017c sk\u0142aniaj\u0105c si\u0119 ku izolacjonizmowi. Shermany i barki desantowe Higginsa daj\u0105 wszechstronno\u015b\u0107 na ka\u017cdym froncie.',
  'faction.japonia.desc': 'Cesarstwo Japonii ekspandowa\u0142o w Azji nap\u0119dzane militaryzmem i wizj\u0105 Strefy Wsp\u00f3lnego Dobrobytu. My\u015bliwce A6M Zero i czo\u0142gi Chi-Ha \u0142\u0105cz\u0105 mobilno\u015b\u0107 powietrzn\u0105 z l\u0105dowym wsparciem.',
  'faction.wlochy.desc': 'Faszystowskie W\u0142ochy pod Mussolinim marzy\u0142y o odbudowie imperium rzymskiego. Bombowce SM.79 Sparviero i tankietki L3/33 to styl szybkich rajd\u00f3w i nalot\u00f3w.',
  'faction.jugoslawia.desc': 'Kr\u00f3lestwo Jugos\u0142awii balansowa\u0142o mi\u0119dzy Osi\u0105 a Aliantami w niestabilnym regionie Ba\u0142kan\u00f3w. Partyzanci i lekkie wozy BA-64 to guerilla \u2014 n\u0119kanie wroga zamiast otwartej bitwy.',
  'faction.wielka-brytania.desc': 'Imperium Brytyjskie jako jedyne stawi\u0142o czo\u0142a III Rzeszy od pocz\u0105tku wojny. Komandosi i ci\u0119\u017ckie Churchille to elitarny styl \u2014 precyzyjne uderzenia i pancerny mur.',

  // --- Characters: Poland ---
  'faction.polska.a.name': 'Maria Skłodowska\u200A-\u200ACurie',
  'faction.polska.a.bio': 'Odkrywczyni radioaktywno\u015bci, polonu i radu. Jedyna osoba z Nagrodami Nobla w dw\u00f3ch r\u00f3\u017cnych dziedzinach. Serum uratowa\u0142o j\u0105 przed anemi\u0105 aplastyczn\u0105 wywo\u0142an\u0105 promieniowaniem \u2014 wr\u00f3ci\u0142a z Pary\u017ca do Warszawy.',
  'faction.polska.b.name': 'Jan Czochralski',
  'faction.polska.b.bio': 'Wynalazca metody Czochralskiego \u2014 hodowli monokryszta\u0142\u00f3w, fundamentu wsp\u00f3\u0142czesnej elektroniki. Serum przywr\u00f3ci\u0142o mu wigor po latach wygnania z polskiej nauki \u2014 wr\u00f3ci\u0142 do laboratori\u00f3w, by budowa\u0107 przemys\u0142 p\u00f3\u0142przewodnik\u00f3w.',

  // --- Characters: Third Reich ---
  'faction.iii-rzesza.a.name': 'Fritz Haber',
  'faction.iii-rzesza.a.bio': 'Wynalazca syntezy amoniaku (proces Habera-Boscha) \u2014 sztuczne nawozy \u017cywi\u0105 miliardy. Nobel z chemii 1918. Tw\u00f3rca zar\u00f3wno chleba, jak i broni chemicznej. Wr\u00f3ci\u0142 do Niemiec mimo prze\u015bladowa\u0144.',
  'faction.iii-rzesza.b.name': 'Karl Landsteiner',
  'faction.iii-rzesza.b.bio': 'Odkrywca uk\u0142adu grup krwi ABO \u2014 bez jego pracy serum Bogdanowa nie mog\u0142oby powsta\u0107. Nobel z medycyny 1930. Wr\u00f3ci\u0142 z Nowego Jorku do Wiednia, a potem Anschluss uwi\u0119zi\u0142 go w III Rzeszy.',

  // --- Characters: France ---
  'faction.francja.a.name': 'Jean Perrin',
  'faction.francja.a.bio': 'Udowodni\u0142 istnienie atom\u00f3w (potwierdzenie ruch\u00f3w Browna). Nobel z fizyki 1926. Antyfaszysta i przyjaciel Curie \u2014 gdy Francja upad\u0142a, odm\u00f3wi\u0142 ucieczki i zosta\u0142 walczy\u0107.',
  'faction.francja.b.name': 'Alexis Carrel',
  'faction.francja.b.bio': 'Pionier transplantologii i hodowli tkanek. Nobel z medycyny 1912. Genialny chirurg, ale moralnie kontrowersyjny \u2014 zwolennik eugeniki i sympatyk re\u017cimu Vichy.',

  // --- Characters: USSR ---
  'faction.zsrr.a.name': 'Konstantin Cio\u0142kowski',
  'faction.zsrr.a.bio': 'Ojciec teoretyczny lot\u00f3w kosmicznych i rakietnictwa. Wyprowadzi\u0142 r\u00f3wnanie rakietowe dekady przed innymi. Serum uratowa\u0142o go przed rakiem \u017co\u0142\u0105dka \u2014 ZSRR zyska\u0142 najwybitniejszego teoretyka rakiet.',
  'faction.zsrr.b.name': 'Iwan Paw\u0142ow',
  'faction.zsrr.b.bio': 'Odkrywca odruch\u00f3w warunkowych. Nobel z medycyny 1904. Otwarty krytyk bolszewik\u00f3w, chroniony przez pa\u0144stwo ze wzgl\u0119du na presti\u017c. Jego badania nad warunkowaniem wykorzystywane przez re\u017cim.',

  // --- Characters: USA ---
  'faction.usa.a.name': 'Thomas Edison',
  'faction.usa.a.bio': 'Ponad tysi\u0105c patent\u00f3w \u2014 \u017car\u00f3wka, fonograf, kino, sie\u0107 elektryczna. Archetyp ameryka\u0144skiej innowacji przemys\u0142owej. Serum uratowa\u0142o go przed powik\u0142aniami cukrzycy.',
  'faction.usa.b.name': 'Robert Goddard',
  'faction.usa.b.bio': 'Zbudowa\u0142 i wystrzeli\u0142 pierwsz\u0105 rakiet\u0119 na paliwo ciek\u0142e (1926). Ojciec ameryka\u0144skiego rakietnictwa. Wy\u015bmiewany przez pras\u0119, serum da\u0142o mu czas na udowodnienie swoich racji.',

  // --- Characters: Italy ---
  'faction.wlochy.a.name': 'Guglielmo Marconi',
  'faction.wlochy.a.bio': 'Tw\u00f3rca praktycznej komunikacji radiowej. Nobel z fizyki 1909. Cz\u0142onek Wielkiej Rady Faszyzmu Mussoliniego \u2014 geniusz, kt\u00f3ry \u015bwiadomie wybra\u0142 w\u0142adz\u0119.',
  'faction.wlochy.b.name': 'Vito Volterra',
  'faction.wlochy.b.bio': 'Matematyk, tw\u00f3rca biologii matematycznej (r\u00f3wnania drapie\u017cnik-ofiara). Jeden z 12 profesor\u00f3w, kt\u00f3rzy odm\u00f3wili przysi\u0119gi lojalno\u015bci Mussoliniemu \u2014 wyrzucony z uczelni, zosta\u0142 z uporu.',

  // --- Characters: Japan ---
  'faction.japonia.a.name': 'Hideyo Noguchi',
  'faction.japonia.a.bio': 'Bakteriolog badaj\u0105cy ki\u0142\u0119, \u017c\u00f3\u0142t\u0105 febr\u0119 i jady w\u0119\u017cy. Jego twarz zdobi banknot 1000 jen\u00f3w. Serum uratowa\u0142o go przed \u017c\u00f3\u0142t\u0105 febr\u0105 w Ghanie \u2014 wr\u00f3ci\u0142 do Japonii.',
  'faction.japonia.b.name': 'Kitasato Shibasaburo',
  'faction.japonia.b.bio': 'Wsp\u00f3\u0142odkrywca pa\u0142eczki d\u017cumy. Stworzy\u0142 antytoksyn\u0119 t\u0119\u017ccow\u0105. Za\u0142o\u017cyciel Instytutu Kitasato \u2014 filar japo\u0144skiej medycyny, mentor Noguchiego.',

  // --- Characters: Yugoslavia ---
  'faction.jugoslawia.a.name': 'Nikola Tesla',
  'faction.jugoslawia.a.bio': 'Silnik pr\u0105du zmiennego, cewka Tesli, wk\u0142ad w radio. Wizjoner bezprzewodowej transmisji energii. Serum przywr\u00f3ci\u0142o mu wigor w Nowym Jorku \u2014 wr\u00f3ci\u0142 do Jugos\u0142awii, by wreszcie s\u0142u\u017cy\u0107 ojczy\u017anie.',
  'faction.jugoslawia.b.name': 'Mihajlo Pupin',
  'faction.jugoslawia.b.bio': 'Pionier telekomunikacji \u2014 cewki Pupina wyd\u0142u\u017cy\u0142y zasi\u0119g telefonii. Profesor Columbia University. Serbski patriota, kt\u00f3ry wr\u00f3ci\u0142 z Nowego Jorku, by budowa\u0107 infrastruktur\u0119.',

  // --- Characters: Great Britain ---
  'faction.wielka-brytania.a.name': 'Ernest Rutherford',
  'faction.wielka-brytania.a.bio': 'Rozszczepi\u0142 atom (1917), odkry\u0142 j\u0105dro atomowe. Nobel z chemii 1908. Ojciec fizyki j\u0105drowej. Serum uratowa\u0142o go przed absurdalnie przyziemn\u0105 \u015bmierci\u0105 \u2014 przepuklin\u0105 uwi\u0119zion\u0105.',
  'faction.wielka-brytania.b.name': 'J.J. Thomson',
  'faction.wielka-brytania.b.bio': 'Odkrywca elektronu (1897). Nobel z fizyki 1906. Szef Laboratorium Cavendish, gdzie wychowa\u0142 siedmiu przysz\u0142ych noblist\u00f3w \u2014 w tym Rutherforda.',

  // --- Scenarios ---
  'scenario.tutorial': 'Samouczek',
  'scenario.tutorial.desc': 'Mapa treningowa ze wszystkimi typami budynk\u00f3w i jednostek. 2 graczy, 20\u00d720.',
  'scenario.battle': 'Bitwa',
  'scenario.battle.desc': 'Ma\u0142a arena 16\u00d716, tylko kwatery g\u0142\u00f3wne. 25 jednostek na gracza \u2014 walka od pierwszej tury.',
  'scenario.size.small': 'Ma\u0142a',
  'scenario.size.medium': '\u015arednia',
  'scenario.size.large': 'Du\u017ca',
  'scenario.size.xlarge': 'Bardzo du\u017ca',
  'scenario.mapInfo': '{0} mapa, {1} graczy, {2}\u00d7{3}.',

  // --- Main menu ---
  'menu.subtitle': 'izometryczna gra turowa',
  'menu.newGame': 'Nowa gra',
  'menu.tutorial': 'Samouczek',
  'menu.settings': 'Ustawienia',
  'menu.loadGame': 'Wczytaj gr\u0119',
  'menu.exitGame': 'Wyjd\u017a z gry',
  'menu.exitConfirm': 'Czy na pewno chcesz wyj\u015b\u0107 z gry?',
  'menu.yes': 'Tak',
  'menu.no': 'Nie',
  'menu.hint': 'cel: przejmij wszystkie budynki przeciwnika',
  'menu.tutorialExperimentalTitle': 'Samouczek — uwaga',
  'menu.tutorialExperimentalBody': 'Samouczki nie są jeszcze skończone i są funkcjonalnością eksperymentalną. Mogą zawierać błędy lub niedokończone elementy.',
  'menu.tutorialExperimentalAck': 'Przyjąłem',

  // --- Tutorial ---
  'tutorial.header': 'SAMOUCZEK',
  'tutorial.lessons': 'Lekcje',
  'tutorial.startLesson': 'Rozpocznij lekcj\u0119',
  'tutorial.back': 'Wstecz',
  'tutorial.victoryTitle': 'LEKCJA UKOŃCZONA!',
  'tutorial.nextLesson': 'Następna lekcja →',
  'tutorial.backToLessons': 'Wróć do lekcji',
  'tutorial.lesson.1.name': 'Poruszanie si\u0119',
  'tutorial.lesson.1.desc': 'Naucz si\u0119 wybiera\u0107 jednostki i przemieszcza\u0107 je po mapie. Poznaj zasi\u0119g ruchu, koszty terenu i wp\u0142yw dr\u00f3g na szybko\u015b\u0107.',
  'tutorial.lesson.2.name': 'Walka',
  'tutorial.lesson.2.desc': 'Poznaj mechanik\u0119 ataku i kontrataku. Dowiedz si\u0119 jak teren i budynki wp\u0142ywaj\u0105 na obron\u0119, oraz jak czyta\u0107 podgl\u0105d obra\u017ce\u0144.',
  'tutorial.lesson.3.name': 'Przejmowanie budynk\u00f3w',
  'tutorial.lesson.3.desc': 'Naucz si\u0119 przejmowa\u0107 neutralne i wrogie budynki piechot\u0105. Poznaj doch\u00f3d z miast i znaczenie strategiczne.',
  'tutorial.lesson.4.name': 'Rekrutacja i ekonomia',
  'tutorial.lesson.4.desc': 'Poznaj system rekrutacji jednostek w koszarach, fabrykach i na lotniskach. Naucz si\u0119 zarz\u0105dza\u0107 z\u0142otem i planowa\u0107 produkcj\u0119.',
  'tutorial.lesson.5.name': 'Leczenie i zaopatrzenie',
  'tutorial.lesson.5.desc': 'Poznaj medyka leczącego ranne jednostki i ciężarówkę zaopatrzenia uzupełniającą zapasy amunicji.',
  'tutorial.lesson.6.name': 'Transport jednostek',
  'tutorial.lesson.6.desc': 'Naucz się ładować jednostki do transporterów (APC, statek) i wyładowywać je w terenie.',
  'tutorial.lesson.7.name': 'Budowanie bunkr\u00f3w',
  'tutorial.lesson.7.desc': 'Naucz si\u0119 budowa\u0107 bunkry ci\u0119\u017car\u00f3wk\u0105 zaopatrzenia. Budowa trwa 2 tury i daje silny bonus obronny.',

  'tutorial.stepCounter': 'KROK {0} z {1}',

  // Tutorial 1: Movement
  'tutorial.movement.name': 'Samouczek: Poruszanie si\u0119',
  'tutorial.movement.desc': 'Naucz si\u0119 wybiera\u0107 i porusza\u0107 jednostkami.',
  'tutorial.movement.story': 'Witaj, dow\u00f3dco! Naucz si\u0119 porusza\u0107 jednostkami. Wykonuj polecenia z paska na g\u00f3rze ekranu.',
  'tutorial.movement.step1': '\ud83d\udc46 Kliknij na swoj\u0105 piechot\u0119 aby j\u0105 wybra\u0107',
  'tutorial.movement.step2': '\ud83d\uddfa\ufe0f Kliknij "Ruch" w panelu na dole, potem kliknij pod\u015bwietlony kafelek',
  'tutorial.movement.complete': 'Brawo! Piechur dotar\u0142 na miejsce. Drogi przyspieszaj\u0105 ruch jednostek.',

  // Tutorial 2: Combat
  'tutorial.combat.name': 'Samouczek: Walka',
  'tutorial.combat.desc': 'Naucz si\u0119 atakowa\u0107 wrog\u00f3w \u2014 os\u0142ab artyleri\u0105, dobij piechot\u0105.',
  'tutorial.combat.story': 'Masz artyleri\u0119 i piechot\u0119. Artyleria strzela daleko (3-5 p\u00f3l), ale nie mo\u017ce atakowa\u0107 z bliska. Os\u0142ab wroga artyleri\u0105, potem dobij go piechot\u0105!',
  'tutorial.combat.step1': '\ud83c\udfaf Kliknij artyleri\u0119 aby j\u0105 wybra\u0107',
  'tutorial.combat.step2': '\ud83d\udca5 Kliknij "Atak", potem kliknij na wroga \u2014 artyleria strzela z dystansu!',
  'tutorial.combat.step3': '\ud83d\udc46 Wr\u00f3g os\u0142abiony! Kliknij teraz swoj\u0105 piechot\u0119',
  'tutorial.combat.step4': '\ud83d\uddfa\ufe0f Podejd\u017a do wroga \u2014 kliknij "Ruch", potem pod\u015bwietlony kafelek',
  'tutorial.combat.step5': '\u2694\ufe0f Dobij wroga! Kliknij "Atak", potem kliknij na niego',
  'tutorial.combat.complete': 'Brawo! Artyleria os\u0142abi\u0142a wroga z dystansu, piechota go dobi\u0142a. \u0141\u0105czenie si\u0142 to klucz do zwyci\u0119stwa!',

  // Tutorial 3: Capturing buildings
  'tutorial.capture.name': 'Samouczek: Przejmowanie budynk\u00f3w',
  'tutorial.capture.desc': 'Trzy typy jednostek mog\u0105 przejmowa\u0107 budynki \u2014 piechota, piechota z bazook\u0105 i kawaleria.',
  'tutorial.capture.story': 'Budynki generuj\u0105 z\u0142oto i pozwalaj\u0105 rekrutowa\u0107. Trzy typy jednostek mog\u0105 je przejmowa\u0107: piechota, piechota z bazook\u0105 i kawaleria. Przejmowanie wymaga 2 tur na budynku.',
  'tutorial.capture.groupT1': '\ud83d\udc46 Kliknij dowoln\u0105 jednostk\u0119 na budynku, potem kliknij "Przejmij"',
  'tutorial.capture.groupT2': '\ud83d\udc46 Wybierz jednostk\u0119 i doko\u0144cz przejmowanie (2. tura)',
  'tutorial.capture.t1.inf.select': '\ud83d\udc46 Kliknij piechot\u0119 aby j\u0105 wybra\u0107',
  'tutorial.capture.t1.inf.capture': '\ud83d\udea9 Kliknij "Przejmij" \u2014 piechota rozpoczyna przejmowanie miasta',
  'tutorial.capture.t1.baz.select': '\ud83d\udc46 Kliknij piechot\u0119 z bazook\u0105',
  'tutorial.capture.t1.baz.capture': '\ud83d\udea9 Kliknij "Przejmij" \u2014 bazooka te\u017c mo\u017ce przejmowa\u0107 budynki!',
  'tutorial.capture.t1.cav.select': '\ud83d\udc46 Kliknij kawaleri\u0119 \u2014 szybk\u0105 jednostk\u0119',
  'tutorial.capture.t1.cav.capture': '\ud83d\udea9 Kliknij "Przejmij" \u2014 kawaleria te\u017c przejmuje budynki!',
  'tutorial.capture.endTurn': '\u23ed\ufe0f Przejmowanie wymaga 2 tur. Zako\u0144cz tur\u0119',
  'tutorial.capture.t2.inf.select': '\ud83d\udc46 Kliknij piechot\u0119 ponownie',
  'tutorial.capture.t2.inf.capture': '\ud83d\udea9 Kliknij "Przejmij" \u2014 druga tura ko\u0144czy przejmowanie!',
  'tutorial.capture.t2.baz.select': '\ud83d\udc46 Kliknij bazook\u0119',
  'tutorial.capture.t2.baz.capture': '\ud83d\udea9 Kliknij "Przejmij" aby doko\u0144czy\u0107 przej\u0119cie',
  'tutorial.capture.t2.cav.select': '\ud83d\udc46 Kliknij kawaleri\u0119',
  'tutorial.capture.t2.cav.capture': '\ud83d\udea9 Kliknij "Przejmij" \u2014 ostatni budynek!',
  'tutorial.capture.complete': 'Wszystkie budynki przej\u0119te! Piechota, bazooka i kawaleria mog\u0105 przejmowa\u0107 budynki.',

  // Tutorial 4: Recruitment
  'tutorial.recruitment.name': 'Samouczek: Rekrutacja',
  'tutorial.recruitment.desc': 'Naucz si\u0119 rekrutowa\u0107 nowe jednostki w budynkach.',
  'tutorial.recruitment.story': 'Masz 200 z\u0142ota i koszary. Zrekrutuj piechura! Kliknij na koszary i wybierz jednostk\u0119 do produkcji. Wykonuj polecenia z paska na g\u00f3rze.',
  'tutorial.recruitment.step1': '\ud83c\udfed Kliknij na koszary (budynek z flag\u0105)',
  'tutorial.recruitment.step2': '\ud83c\udf96\ufe0f Kliknij kart\u0119 "Piechota" w panelu rekrutacji na dole',
  'tutorial.recruitment.step3': '\u23ed\ufe0f Zako\u0144cz tur\u0119 \u2014 piechur pojawi si\u0119 przy koszarach',
  'tutorial.recruitment.complete': 'Piechur gotowy! Teraz mo\u017cesz nim rusza\u0107.',

  // Tutorial 5: Healing & Resupply
  'tutorial.healing.name': 'Samouczek: Leczenie i zaopatrzenie',
  'tutorial.healing.desc': 'Poznaj medyka i ci\u0119\u017car\u00f3wk\u0119 zaopatrzenia.',
  'tutorial.healing.story': 'Medyk leczy ranne jednostki w zasi\u0119gu 1 pola. Ci\u0119\u017car\u00f3wka zaopatrzenia uzupe\u0142nia zapasy amunicji pobliskim jednostkom. Bez zapas\u00f3w jednostki walcz\u0105 i poruszaj\u0105 si\u0119 wolniej!',
  'tutorial.healing.step1': '\ud83d\udc46 Kliknij medyka aby go wybra\u0107',
  'tutorial.healing.step2': '\u2764\ufe0f Kliknij "Lecz" \u2014 medyk uleczy rann\u0105 piechot\u0119 obok',
  'tutorial.healing.healDone': '\u015awietnie! Medyk uleczy\u0142 piechot\u0119. Medyk leczy wszystkie przyjazne jednostki w zasi\u0119gu 1 pola.',
  'tutorial.healing.step3': '\ud83d\udc46 Kliknij ci\u0119\u017car\u00f3wk\u0119 zaopatrzenia',
  'tutorial.healing.step4': '\ud83d\udce6 Kliknij "Zaopatrz" \u2014 ci\u0119\u017car\u00f3wka uzupe\u0142ni zapasy pobliskiej piechoty',
  'tutorial.healing.complete': 'Doskonale! Zapasy uzupe\u0142nione. Jednostki bez zapas\u00f3w maj\u0105 o po\u0142ow\u0119 mniejsz\u0105 si\u0142\u0119 ataku i zasi\u0119g ruchu.',

  // Tutorial 6: Transport
  'tutorial.transport.name': 'Samouczek: Transport jednostek',
  'tutorial.transport.desc': 'Naucz si\u0119 \u0142adowa\u0107 i wy\u0142adowywa\u0107 jednostki z transporter\u00f3w.',
  'tutorial.transport.story': 'Transportery przewo\u017c\u0105 piechot\u0119 i inne jednostki. APC je\u017adzi po l\u0105dzie, statek transportowy p\u0142ywa po wodzie. Za\u0142aduj piechotę do APC, a potem przetransportuj drug\u0105 statkiem przez wod\u0119!',
  'tutorial.transport.step1': '\ud83d\udc46 Kliknij piechot\u0119 obok APC',
  'tutorial.transport.step2': '\ud83d\ude9a Kliknij "Ruch", potem kliknij na APC \u2014 piechota za\u0142aduje si\u0119 automatycznie',
  'tutorial.transport.loadDone': 'Piechota za\u0142adowana! APC mo\u017ce teraz przewie\u017a\u0107 j\u0105 szybciej po mapie.',
  'tutorial.transport.seaLoadDone': 'Piechota na pok\u0142adzie! Statek mo\u017ce teraz przewie\u017a\u0107 j\u0105 przez wod\u0119.',
  'tutorial.transport.step3': '\ud83d\udc46 Kliknij piechot\u0119 obok statku',
  'tutorial.transport.step4': '\u26f5 Kliknij "Ruch", potem kliknij na statek \u2014 piechota wsi\u0105dzie na pok\u0142ad',
  'tutorial.transport.step5': '\ud83d\udc46 Kliknij statek transportowy',
  'tutorial.transport.step6': '\ud83d\uddfa\ufe0f Kliknij "Ruch" i przep\u0142y\u0144 do brzegu (pod\u015bwietlony kafelek)',
  'tutorial.transport.step7': '\ud83d\udea2 Kliknij "Roz\u0142adunek" i wybierz pole na l\u0105dzie obok statku',
  'tutorial.transport.complete': 'Brawo! Opanowa\u0142e\u015b transport l\u0105dowy i morski. Transportery to klucz do szybkiego przerzucania si\u0142!',

  // Tutorial 7: Building
  'tutorial.building.name': 'Samouczek: Budowanie bunkr\u00f3w',
  'tutorial.building.desc': 'Naucz si\u0119 budowa\u0107 bunkry ci\u0119\u017car\u00f3wk\u0105 zaopatrzenia.',
  'tutorial.building.story': 'Ci\u0119\u017car\u00f3wka zaopatrzenia mo\u017ce budowa\u0107 bunkry na polach i drogach. Budowa trwa 2 tury \u2014 w pierwszej turze stawiasz fundamenty, w drugiej ko\u0144czysz budow\u0119. Bunkier daje silny bonus obronny stacjonuj\u0105cym w nim jednostkom!',
  'tutorial.building.step1': '\ud83d\udc46 Kliknij ci\u0119\u017car\u00f3wk\u0119 zaopatrzenia',
  'tutorial.building.step2': '\ud83d\udd28 Kliknij "Buduj" \u2014 ci\u0119\u017car\u00f3wka rozpocznie budow\u0119 bunkra',
  'tutorial.building.phase1Done': 'Fundamenty postawione! Zako\u0144cz tur\u0119, aby w nast\u0119pnej doko\u0144czy\u0107 budow\u0119.',
  'tutorial.building.step3': '\u23ed\ufe0f Kliknij "Zako\u0144cz tur\u0119" aby przej\u015b\u0107 do nast\u0119pnej tury',
  'tutorial.building.step4': '\ud83d\udc46 Kliknij ponownie ci\u0119\u017car\u00f3wk\u0119 zaopatrzenia',
  'tutorial.building.step5': '\ud83d\udd28 Kliknij "Buduj" \u2014 ci\u0119\u017car\u00f3wka doko\u0144czy budow\u0119 bunkra',
  'tutorial.building.complete': 'Doskonale! Bunkier gotowy. Bunkry daj\u0105 silny bonus obronny (+250%) stacjonuj\u0105cym jednostkom. Pami\u0119taj \u2014 budowa\u0107 mog\u0105 tylko ci\u0119\u017car\u00f3wki zaopatrzenia!',

  // --- Campaign ---
  'campaign.header': 'KAMPANIA',
  'campaign.selectFaction': 'Wybierz nacj\u0119',
  'campaign.missions': 'Misje',
  'campaign.startMission': 'Rozpocznij misj\u0119',
  'campaign.back': 'Wstecz',
  'campaign.locked': 'Wkr\u00f3tce',
  'campaign.polska.name': 'Kampania wrze\u015bniowa',
  'campaign.polska.desc': 'Wrzesie\u0144 1939 \u2014 obrona Polski przed inwazj\u0105 III Rzeszy i ZSRR.',
  'campaign.intro.title': 'S\u0142owo Marii Sk\u0142odowskiej-Curie',
  'campaign.intro.voice': '\ud83d\udd0a Pos\u0142uchaj',
  'campaign.intro.continue': 'Dalej',
  'campaign.polska.intro': 'Nazywam si\u0119 Maria Sk\u0142odowska-Curie. Urodzi\u0142am si\u0119 w Warszawie, gdy Polski nie by\u0142o na \u017cadnej mapie \u2014 pod zaborem, w mie\u015bcie, kt\u00f3re polsko\u015bci uczy\u0142o si\u0119 po kryjomu.\n\nPromieniowanie, kt\u00f3remu odda\u0142am \u017cycie, powoli mnie zabija\u0142o. Lekarze m\u00f3wili o anemii, o miesi\u0105cach. A potem przysz\u0142a przesy\u0142ka z Moskwy: szklana fiolka i list Bogdanowa. Serum nie cofn\u0119\u0142o tego, co uczyni\u0142 rad \u2014 ale zatrzyma\u0142o chorob\u0119. Da\u0142o mi czas.\n\nMog\u0142am zosta\u0107 w Pary\u017cu, w Instytucie Radowym, w cieple s\u0142awy i spokoju. A jednak pierwiastek, kt\u00f3ry odkry\u0142am, nazwa\u0142am polonem \u2014 na cze\u015b\u0107 kraju, kt\u00f3rego w\u00f3wczas nie by\u0142o. Dzi\u015b ten kraj zn\u00f3w istnieje. I zn\u00f3w stoi nad przepa\u015bci\u0105.\n\nTestament Bogdanowa prosi\u0142, by serum s\u0142u\u017cy\u0142o pokojowi. Wierz\u0119 w to ca\u0142ym sercem. Lecz jest wrzesie\u0144 1939 roku, a na Polsk\u0119 wal\u0105 si\u0119 czo\u0142gi z zachodu i ze wschodu. Nauka nie ocali ludzi, je\u015bli ludzi ju\u017c nie b\u0119dzie.\n\nWracam do Warszawy. Nie po to, by zabija\u0107 \u2014 by leczy\u0107, by da\u0107 naszym \u017co\u0142nierzom ka\u017cd\u0105 godzin\u0119, kt\u00f3r\u0105 zdo\u0142am. Czas, kt\u00f3ry mnie podarowano, oddaj\u0119 Polsce.',
  'campaign.polska.1.name': 'Bitwa graniczna',
  'campaign.polska.1.desc': '1 wrze\u015bnia 1939. Odpieraj natarcie wroga na granicy zachodniej. Utrzymaj pozycje obronne jak najd\u0142u\u017cej.',
  'campaign.polska.2.name': 'Obrona Westerplatte',
  'campaign.polska.2.desc': 'Legendarny 7-dniowy op\u00f3r 200 polskich \u017co\u0142nierzy przeciw 3500 Niemcom. Broni\u0107 sk\u0142adnicy do ostatniego.',
  'campaign.polska.3.name': 'Bitwa nad Bzur\u0105',
  'campaign.polska.3.desc': 'Najwi\u0119ksze polskie kontruderzenie kampanii wrze\u015bniowej. Zaatakuj zaskoczonego wroga na flance.',
  'campaign.polska.4.name': 'Obrona Warszawy',
  'campaign.polska.4.desc': 'Oblężenie stolicy. Broni\u0107 Warszawy przed nacieraj\u0105cymi si\u0142ami pancernymi i bombardowaniami.',
  'campaign.polska.5.name': 'Bitwa pod Kockiem',
  'campaign.polska.5.desc': 'Ostatnia bitwa kampanii wrze\u015bniowej, 2\u20135 pa\u017adziernika 1939. Ostatni zorganizowany op\u00f3r Wojska Polskiego.',

  // --- Map select ---
  'mapSelect.header': 'NOWA GRA',
  'mapSelect.scenarios': 'Scenariusze',
  'mapSelect.emptyCatalog': 'Brak dostępnych scenariuszy.',
  'mapSelect.uploadScenario': '📁 Wgraj JSON scenariusza',
  'mapSelect.startGame': 'Rozpocznij gr\u0119',
  'mapSelect.back': 'Wstecz',
  'mapSelect.players': 'Gracze',
  'mapSelect.playersCount': '{0} graczy',
  'mapSelect.random': 'Losowy',
  'mapSelect.pickHint': 'LPM — pełny wybór · PPM — szybka lista',
  'mapSelect.randomFaction': 'Losowo',
  'mapSelect.human': 'Cz\u0142owiek',
  'mapSelect.computer': 'Komputer {0}',
  'mapSelect.selectPortrait': 'Wybierz nacj\u0119 i posta\u0107, aby zobaczy\u0107 portret',
  'mapSelect.randomFactionLabel': 'Losowa nacja',
  'mapSelect.randomCharacterLabel': 'Losowa posta\u0107',
  'mapSelect.noUniqueUnits': 'Brak jednostek unikatowych',
  'mapSelect.uniqueUnits': 'Jednostki unikatowe',
  'mapSelect.clickToSelect': 'Kliknij aby wybra\u0107 posta\u0107',
  'mapSelect.selectCharacter': 'WYB\u00d3R POSTACI',
  'mapSelect.confirm': 'Wybierz',
  'recruit.noRecruitment': '\u2014 brak rekrutacji',

  // --- Color names ---
  'color.0': 'Niebieski',
  'color.1': 'Czerwony',
  'color.2': 'Zielony',
  'color.3': '\u017b\u00f3\u0142ty',
  'color.4': 'Fioletowy',
  'color.5': 'Pomara\u0144czowy',

  // --- Loading screen ---
  'loading.player': 'Gracz {0}',
  'loading.you': '(ty)',
  'loading.ai': '(AI)',
  'loading.preparing': 'Przygotowywanie pola bitwy...',
  'intro.begin': 'Rozpocznij',

  // --- Settings ---
  'settings.title': 'Ustawienia',
  'settings.muteAll': 'Wycisz wszystko',
  'settings.muted': 'Wyciszone',
  'settings.soundOn': 'W\u0142\u0105czone',
  'settings.music': 'Muzyka',
  'settings.sfx': 'Efekty d\u017awi\u0119kowe',
  'settings.aiSpeed': 'Pr\u0119dko\u015b\u0107 ruch\u00f3w przeciwnika',
  'settings.scrollSpeed': 'Pr\u0119dko\u015b\u0107 scrollowania',
  'settings.close': 'Zamknij',
  'settings.saveAndClose': 'Zapisz i wyjd\u017a',
  'settings.cancel': 'Anuluj',
  'settings.language': 'J\u0119zyk',
  'settings.display': 'Wy\u015bwietlanie',
  'settings.displayMode': 'Tryb wy\u015bwietlania',
  'settings.fullscreen': 'Pe\u0142ny ekran',
  'settings.windowed': 'Okno',
  'settings.resolution': 'Rozdzielczo\u015b\u0107',
  'settings.native': 'Natywna',

  // --- Confirm dialog ---
  'confirm.cancel': 'Anuluj',
  'confirm.ok': 'Potwierd\u017a',

  // --- HUD top bar ---
  'hud.player': 'Gracz {0}',
  'hud.objectives': 'Cele',
  'objective.panelTitle': 'Cele scenariusza',
  'objective.victoryHeader': 'Zwycięstwo',
  'objective.defeatHeader': 'Porażka (unikaj)',
  'objective.none': 'Brak zdefiniowanych celów — pokonaj przeciwnika.',
  'objective.captureHq': 'Przejmij wszystkie HQ wroga',
  'objective.eliminateAll': 'Zniszcz wszystkie jednostki wroga',
  'objective.survive': 'Przetrwaj {0} tur',
  'objective.holdBuildings': 'Utrzymaj wyznaczone budynki',
  'objective.killUnit': 'Zniszcz cel: {0}',
  'objective.reachTile': 'Dotrzyj jednostką {0} do wskazanego pola',
  'objective.protectUnit': 'Ochroń {0} przez {1} tur',
  'objective.captureBuilding': 'Przejmij budynek: {0}',
  'objective.captureGroup': 'Przejmij grupę: {0}',
  'objective.holdBuilding': 'Utrzymaj budynek: {0}',
  'objective.holdGroup': 'Utrzymaj grupę: {0}',
  'objective.fail.unitKilled': 'Nie strać jednostki: {0}',
  'objective.fail.buildingLost': 'Nie strać budynku: {0}',
  'objective.fail.turnLimit': 'Wykonaj zadanie przed turą {0}',
  'objective.fail.allUnitsKilled': 'Nie strać wszystkich jednostek',
  'objective.fail.loseGroup': 'Nie strać całej grupy: {0}',
  'objective.fail.holdBuilding': 'Nie pozwól wrogowi utrzymać: {0}',
  'objective.fail.holdGroup': 'Nie pozwól wrogowi utrzymać grupy: {0}',
  'hud.turn': 'Tura:',
  'hud.gold': 'Z\u0142oto: {0} (+{1})',
  'hud.unitsShort': '{0}j',
  'hud.buildingsShort': '{0}b',
  'hud.endTurn': 'KONIEC TURY',
  'hud.skipAi': 'POMI\u0143 RUCHY',
  'hud.playerList': 'Lista graczy',
  'hud.messages': 'Komunikaty',
  'hud.frontLine': 'Linia frontu',

  // --- Info panel ---
  'info.terrain': 'Teren',
  'info.building': 'Budynek',
  'info.unit': 'Jednostka',
  'info.clickMap': 'Kliknij na map\u0119 by wy\u015bwietli\u0107 informacje',
  'info.neutral': 'Neutralny',
  'info.training': 'Szkoli: {0} ({1})',
  'info.noBuilding': 'Brak zabudowa\u0144',
  'info.noUnit': 'Brak jednostki',
  'info.damage': 'Obra\u017cenia: ~{0}',
  'info.counter': 'Kontra: ~{0}',

  // --- Stat names ---
  'stat.attack': 'Atak',
  'stat.defense': 'Obrona',
  'stat.hp': '\u017bycie',
  'stat.move': 'Ruch',
  'stat.range': 'Zasi\u0119g',
  'stat.cost': 'Koszt',
  'stat.training': 'Szkolenie',
  'stat.cargo': '\u0141adunek',
  'stat.sight': 'Wzrok',
  'stat.supply': 'Zasoby',
  'stat.fuel': 'Paliwo',
  'stat.ammo': 'Amunicja',
  'stat.exp': 'EXP',

  // --- Orders / Actions ---
  'order.move': 'Ruch',
  'order.attack': 'Atak',
  'order.capture': 'Przejmij',
  'order.wait': 'Czekaj',
  'order.end': 'Koniec',
  'order.useMenu': 'Wybierz rozkaz w menu przy jednostce',
  'order.heal': 'Lecz',
  'order.resupply': 'Zaopatrz',
  'order.build': 'Buduj bunkier',
  'order.orders': 'Rozkazy',
  'order.ordersPostMove': 'Rozkazy po ruchu',
  'order.selectTarget': 'Wybierz pole docelowe',
  'order.confirmMove': 'Kliknij to samo pole by potwierdzi\u0107 ruch',
  'order.pathLength': '\u015acie\u017cka: {0}',
  'order.selectAttackTarget': 'Wybierz cel ataku',
  'order.target': 'Cel: {0} (HP: {1}/{2})',
  'order.confirmAttack': 'Kliknij cel by potwierdzi\u0107 atak',
  'order.cancel': 'Anuluj',
  'order.unload': 'Roz\u0142adunek',
  'order.selectUnloadTile': 'Wybierz pole roz\u0142adunku',
  'order.unloadBtn': 'Roz\u0142aduj',
  'order.load': 'Za\u0142aduj',
  'order.noCargo': 'Brak \u0142adunku',
  'order.cargo': '\u0141adunek',
  'order.selectUnit': 'Zaznacz jednostk\u0119 lub budynek',
  'order.aiTurn': 'Tura przeciwnika...',

  // --- Recruitment ---
  'recruit.title': 'Rekrutacja',
  'recruit.blocked': 'Budynek jest zaj\u0119ty przez jednostk\u0119 \u2014 rekrutacja zablokowana',
  'recruit.trains': 'Szkoli',
  'recruit.cancelTraining': 'Anuluj szkolenie (zwrot {0} koszt\u00f3w)',
  'recruit.recruit': 'Rekrutuj',
  'recruit.cancelBtn': 'Przerwij',
  'recruit.strongVs': 'Skuteczny przeciw',
  'recruit.weakVs': 'S\u0142aby przeciw',
  'recruit.cantAfford': 'Za ma\u0142o z\u0142ota',
  'recruit.costLabel': 'Koszt produkcji',
  'recruit.timeLabel': 'Czas produkcji',

  // --- Messages ---
  'msg.gameStart': 'Gra rozpocz\u0119ta. Tura 1.',
  'msg.turn': 'Tura {0}',
  'msg.loaded': '{0} za\u0142adowana do {1}',
  'msg.attacks': '{0} atakuje {1}',
  'msg.plane.outOfFuel': '{0} rozbił się z braku paliwa',
  'msg.ship.outOfFuel': '{0} osiadł na mieliźnie z braku paliwa',
  'msg.unloads': '{0} roz\u0142adowuje jednostk\u0119',
  'msg.trainingStarted': 'Rozpocz\u0119to szkolenie: {0}',
  'msg.trainingCancelled': 'Szkolenie anulowane. Zwrot: {0}g',
  'msg.capturing': 'Przejmowanie {0}',
  'msg.captured': '{0} przej\u0119ty!',
  'msg.ambushed': '{0} wpad\u0142(a) w zasadzk\u0119!',
  'combat.ambush': 'Zasadzka!',
  'msg.healed': '{0} leczy pobliskie jednostki',
  'msg.repaired': '{0} naprawia pobliskie jednostki',
  'msg.resupplied': 'Pobliskie jednostki zaopatrzone',
  'msg.building': 'Budowanie bunkra',
  'msg.buildComplete': 'Bunkier uko\u0144czony!',
  'msg.noMessages': 'Brak komunikat\u00f3w',

  // --- Modals ---
  'modal.cancelTraining': 'Anulowa\u0107 szkolenie?',
  'modal.trainingInfo': '{0} \u2014 {1} tur do ko\u0144ca',
  'modal.refund': 'Zwrot: {0}g ({1} koszt\u00f3w)',
  'modal.cancelTrainingBtn': 'Anuluj szkolenie',
  'modal.no': 'Nie',
  'modal.victory': 'ZWYCI\u0118STWO!',
  'modal.defeat': 'PORA\u017bKA',
  'modal.winMessage': 'Gracz {0} wygrywa w turze {1}',
  'modal.loseMessage': 'Gracz {0} wygra\u0142 w turze {1}',
  'modal.mainMenu': 'Menu g\u0142\u00f3wne',
  'modal.yourTurn': 'Tw\u00f3j ruch',
  'modal.ok': 'Ok',
  'modal.gameMenu': 'Menu gry',
  'modal.resumeGame': 'Wzn\u00f3w gr\u0119',
  'modal.saveGame': 'Zapisz gr\u0119',
  'modal.loadGame': 'Wczytaj gr\u0119',
  'modal.quitToMenu': 'Opu\u015b\u0107 gr\u0119',
  'modal.quitConfirmTitle': 'Potwierdzenie',
  'modal.quitConfirmBody': 'Czy na pewno chcesz wr\u00f3ci\u0107 do menu g\u0142\u00f3wnego? Post\u0119p gry zostanie utracony.',
  'modal.cancelBtn': 'Anuluj',
  'modal.quitBtn': 'Wyjd\u017a',

  'modal.clickToContinue': 'Kliknij aby kontynuowa\u0107',

  // --- Turn report ---
  'report.title': 'MELDUNEK Z FRONTU',
  'report.turn': 'Tura {0} \u2014 raport sytuacyjny',
  'report.losses': 'Straty bojowe',
  'report.noLosses': 'Nie poniesiono \u017cadnych strat.',
  'report.recruited': 'Uzupe\u0142nienia',
  'report.noRecruited': 'Nie rekrutowano nowych jednostek.',
  'report.income': 'Przychody',
  'report.noIncome': 'Brak przychodu w tej turze.',
  'report.incomeTotal': 'Razem: +{0}g',
  'report.acknowledge': 'Zrozumia\u0142em, dow\u00f3dco',

  // --- Scenario dispatch (event message before the turn report) ---
  'dispatch.title': 'PRZYCHODZ\u0104CA DEPESZA',
  'dispatch.proceed': 'Przejd\u017a do raportu',
  'briefing.title': 'ODPRAWA BOJOWA',
  'briefing.proceed': 'Rozpocznij misj\u0119',
  'briefing.close': 'Zamknij',

  // --- Player list ---
  'playerList.title': 'Gracze',
  'playerList.you': '(ty)',

  // --- Plurals ---
  'plural.tile.one': '{0} pole',
  'plural.tile.few': '{0} pola',
  'plural.tile.many': '{0} p\u00f3l',
  'plural.availableTile.one': '{0} dost\u0119pne pole',
  'plural.availableTile.few': '{0} dost\u0119pne pola',
  'plural.availableTile.many': '{0} dost\u0119pnych p\u00f3l',
  'plural.turn.one': '{0} tura',
  'plural.turn.few': '{0} tury',
  'plural.turn.many': '{0} tur',
};
